export class DynamicDialogConfig<T = any> {
    data?: T;
    header?: string;
    footer?: string;
    width?: string;
    height?: string;
    closeOnEscape?: boolean;
    baseZIndex?: number;
    autoZIndex?: boolean;
    dismissableMask?: boolean;
    rtl?: boolean;
    style?: any;
    contentStyle?: any;
    styleClass?: string;
    transitionOptions?: string;
    closable?: boolean;
    showHeader?: boolean;
    modal?: boolean;
    maskStyleClass?: string;
    resizable?: boolean;
    draggable?: boolean;
    keepInViewport?: boolean;
    minX?: number;
    minY?: number;
    maximizable?: boolean;
    maximizeIcon?: string;
    minimizeIcon?: string;
    position?: string;
}
